import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import createTrack from 'services/actions/tracker_actions';
import { setCookie, getCookie, incrementViewCount } from 'services/actions/cookies_actions';
import { Container } from './styles';

interface BidWinnerProps {
  showModalBidWinner: boolean;
  edital: string;
  orgao_nome: string;
  contato_nome: string;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalBidWinner = (props: BidWinnerProps) => {
  const { setShowModal, showModalBidWinner, edital, orgao_nome, contato_nome } = props;
  const viewCountCookieName = 'seguroGarantiaViewCount';

  const handleClick = () => {
    createTrack('Parceria Junto Seguros');
    window.open(
      'https://api.whatsapp.com/send?phone=551137899117&text=Ol%C3%A1,%20gostaria%20de%20fazer%20uma%20cota%C3%A7%C3%A3o!',
      '_blank',
    );
  };

  useEffect(() => {
    const viewCount = parseInt(getCookie(viewCountCookieName) || '0', 10);
    if (viewCount < 5) {
      setShowModal(true);
      incrementViewCount(viewCountCookieName);
    } else {
      setShowModal(false);
    }
  }, []);

  useEffect(() => {
    if (showModalBidWinner) setCookie('seguroGarantia', true);
  }, [showModalBidWinner]);

  return (
    <Modal show={showModalBidWinner} size="lg">
      <Container>
        <div className="position-relative bg-modal">
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={() => setShowModal(false)}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="row p-5">
            <div className="col-md-12">
              <h3 className="mt-4 mb-0">
                <strong>Parabéns,</strong>
              </h3>
              <h1 className="font-weight-bold mb-3 mt-3 mt-5">{contato_nome}</h1>
              <h5 className="display-5">
                Vimos que <strong>você ganhou uma licitação!</strong>
              </h5>
              <h5 className="display-5 mt-4">
                <strong>Edital: </strong>
                {edital}
              </h5>
              <h5 className="display-6">
                <strong>Órgão: </strong>
                {orgao_nome}
              </h5>
              <h5 className="display-6 mt-4">
                Essa licitação <strong>exige seguro garantia</strong>
                <br />e podemos te ajudar com isso!
              </h5>
              <button
                type="button"
                className="btn btn-seguro-garantia mt-4 font-weight-bold"
                onClick={() => handleClick()}
              >
                Faça uma cotação online agora
              </button>
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalBidWinner;
